// @ts-nocheck
import { useUserInfo } from '@dev-togetherprice/api.user';
import AdminAvatar from '@dev-togetherprice/components.admin-avatar';
import VerticalCentered from '@dev-togetherprice/components.vertical-centered';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    adminAvatar: {
        cursor: 'pointer',
    },
    fullName: {
        marginTop: theme.spacing(3),
        fontWeight: 500,
        fontSize: '16px',
    },
}));
const SidebarAdminWrapper = ({ isPublic, showSidebar, navigateToUrl, classes: newClasses = {}, }) => {
    const baseClasses = useStyles();
    const allClasses = mergeClasses({
        newClasses,
        baseClasses,
        Component: SidebarAdminWrapper,
    });
    const userInfo = !isPublic && useUserInfo();
    const fullName = [userInfo === null || userInfo === void 0 ? void 0 : userInfo.name, userInfo === null || userInfo === void 0 ? void 0 : userInfo.surname]
        .filter(Boolean)
        .join(' ');
    return (React.createElement(Grid, { item: true },
        userInfo && (React.createElement(VerticalCentered, null,
            React.createElement(Grid, { item: true, className: allClasses.adminAvatar },
                React.createElement(AdminAvatar, { fullName: fullName, size: showSidebar ? 96 : 48, profilePictureUrl: userInfo === null || userInfo === void 0 ? void 0 : userInfo.image, verified: userInfo === null || userInfo === void 0 ? void 0 : userInfo.verified, trust: userInfo === null || userInfo === void 0 ? void 0 : userInfo.trust, onClick: () => navigateToUrl('/account/settings'), lazyOptions: { visibleByDefault: true }, eager: true })))),
        React.createElement(VerticalCentered, null,
            React.createElement(Typography, { component: 'div', variant: 'h6', align: 'center', "aria-label": fullName, className: allClasses.fullName, noWrap: true }, showSidebar ? fullName : ''))));
};
export default SidebarAdminWrapper;
